import { render } from "./MenuHeaderComponent.vue?vue&type=template&id=0c7427b5"
import script from "./MenuHeaderComponent.vue?vue&type=script&lang=js"
export * from "./MenuHeaderComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__